import { render, staticRenderFns } from "./deleteRequest.vue?vue&type=template&id=52e37d01&scoped=true&"
import script from "./deleteRequest.vue?vue&type=script&lang=js&"
export * from "./deleteRequest.vue?vue&type=script&lang=js&"
import style0 from "./deleteRequest.vue?vue&type=style&index=0&id=52e37d01&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e37d01",
  null
  
)

export default component.exports